import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import Loader from "../../Component/Loader";
import useBreakPoints from "../../hooks/useBreakPoints";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Box, IconButton, Modal, Input } from "@mui/material";
import moment from "moment";
import { Minus, Plus, SquareArrowOutUpRight, X } from "lucide-react";
import { ChevronDown, ChevronRight, Users, Wallet, Calendar, User } from 'lucide-react';
import ReferralTreeComponent from "./ReferralTreeComponent";
const cartStyles = {
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  breadcrumb: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px",
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "40px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    textAlign: "left",
    padding: "10px",
    borderBottom: "1px solid #ddd",
    fontWeight: "normal",
  },
  td: {
    padding: "20px 10px",
    borderBottom: "1px solid #ddd",
  },
  productImage: {
    width: "120px",
    height: "120px",
    objectFit: "cover",
    borderRadius: 12,
  },
  productDetails: {
    display: "flex",
    alignItems: "center",
  },
  productInfo: {
    // marginLeft: "20px",
  },
  quantityControl: {
    display: "flex",
    alignItems: "center",
  },
  quantityButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "5px",
  },
  quantityInput: {
    width: "40px",
    textAlign: "center",
    margin: "0 10px",
    border: "1px solid #ddd",
    padding: "5px",
  },
  totalContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    // marginBottom: "20px",
    marginTop: "20px",
  },
  totalLabel: {
    fontSize: "18px",
    fontWeight: "bold",
    marginRight: "20px",
  },
  totalAmount: {
    fontSize: "24px",
    fontWeight: "bold",
  },
  checkoutInfo: {
    fontSize: "12px",
    color: "#666",
    textAlign: "right",
    marginBottom: "5px",
  },
  checkoutButton: {
    padding: "5px",
    backgroundColor: "#00205b",
    color: "white",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    marginBottom: "10px",
    width: 320,
  },
  altPaymentContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: 320,
  },
  altPaymentButton: {
    width: "48%",
    padding: "15px",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

const walletStyles = {
  container: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Arial, sans-serif'
  },
  walletSection: {
    backgroundColor: '#f5f0ee',
    color: '#333333',
    padding: '24px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px'
  },
  referralSection: {
    backgroundColor: '#f5f0ee',
    color: '#333333',
    padding: '24px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    marginTop: '12px'
  },
  copySection: {
    display: 'flex',
    columnGap: '8px'
  },
  walletTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    margin: '0'
  },
  balanceLabel: {
    fontSize: '14px',
    opacity: '0.8',
    marginTop: '12px',
    marginBottom: '4px'
  },
  pointLabel: {
    fontSize: '14px',
    opacity: '0.8',
    marginTop: '12px',
    marginBottom: '4px',
    fontWeight: 700
  },
  balanceWrapper: {
    display: 'flex',
    alignItems: 'center',
    margin: '4px 0 0 0'
  },
  balanceAmount: {
    fontSize: '28px',
    fontWeight: 'bold',
    marginRight: '8px'
  },
  coinIcon: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#ffd700',
    border: '2px solid #e6c200',
    display: 'inline-block',
    marginRight: '4px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  coinIcon2: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    backgroundColor: '#ffc107',
    border: '2px solid #d39e00',
    display: 'inline-block',
    marginRight: '4px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  useButton: {
    backgroundColor: '#2563eb',
    color: '#ffffff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    fontWeight: '500',
    fontSize: '14px',
    cursor: 'pointer',
    marginTop: '16px'
  },
  redemptionSection: {
    padding: '24px'
  },
  redemptionTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '12px'
  },
  conditionsList: {
    listStyle: 'none',
    padding: '0',
    margin: '0'
  },
  conditionItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '3px'
  },
  bulletPoint: {
    color: '#2563eb',
    marginRight: '8px'
  }
};

const Profile = () => {
  const navigate = useNavigate();
  const { isMobile } = useBreakPoints();
  let userInfo = JSON.parse(localStorage?.getItem("userDetails"));
  let rowCount = 0;
  const [step, setStep] = useState("step1");
  const [loading, setloading] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  console.log('userDetails1903: ', userDetails);
  const [selectedId, setSelectedId] = useState();
  const [editAddressModal, setEditAddressModal] = useState(false);
  const [orderList, setOrderList] = useState([]);
  console.log("orderList: ", orderList);

  const [orderData, setOrderData] = useState([]);
  console.log("orderData: ", orderData);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [oldShowPassword, setOldShowPassword] = useState(false);
  const [newShowPassword, setNewShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);

  const [rewardSettings, setRewardSettings] = useState([]);
  console.log('rewardSettings: ', rewardSettings);

  const [changePasswordInputData, setChangePasswordInputData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [changePasswordInputDataError, setChangePasswordInputDataError] =
    useState({
      oldPassword: false,
      newPassword: false,
      confirmPassword: false,
    });

  const [userInputData, setUserInputData] = useState({
    name: userInfo?.customerName,
    email: userInfo?.customerEmail,
    mobileNo: userInfo?.customerMobile
      ? userInfo?.customerMobile?.substring(3)
      : "",
    alternativeMobileNo: userInfo?.customerAlterMobile
      ? userInfo?.customerAlterMobile?.substring(3)
      : "",
  });

  const [userInputDataError, setUserInputDataError] = useState({
    name: false,
    email: false,
    mobileNo: false,
  });

  const [addressInputData, setAddressInputData] = useState({
    address: "",
    city: "",
    state: "",
    pincode: "",
    country: "India",
  });

  const [addressInputDataError, setAddressInputDataError] = useState({
    address: false,
    city: false,
    state: false,
    pincode: false,
    country: false,
  });

  const [addressList, setAddressList] = useState([]);
  const [copied, setCopied] = useState(false);
  const [urlCopied, setUrlCopied] = useState(false);
  const [expandedNodes, setExpandedNodes] = useState(new Set([10, 20, 23, 24, 25]));
  const handleCopyReferralCode = async (referralCode) => {
    try {
      await navigator.clipboard.writeText(referralCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
      return true;
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = referralCode;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      return true;
    }
  };

  const handleRowClick = (id) => {
    navigate(`/order-details/${id}`); // redirect with dynamic id
  };

  // Your existing function modified to always show share menu
  const handleShareReferralUrl = async (referralUrl, referralCode) => {
    const shareMessage = `🎉 Join me on K9 Interiors! 
Use my referral code: ${referralCode}
Open this link and get exclusive rewards!
${referralUrl}
Happy shopping! 🛍️`;

    try {
      // Try to use Web Share API if available (mobile devices)
      if (navigator.share && navigator.canShare && navigator.canShare({ text: shareMessage, url: referralUrl })) {
        await navigator.share({
          title: 'Join K9 Interiors!',
          text: shareMessage,
          url: referralUrl
        });
      } else if (navigator.share) {
        // Try without URL parameter for better compatibility
        await navigator.share({
          title: 'Join K9 Interiors!',
          text: shareMessage
        });
      } else {
        // Always show custom share menu (which includes copy option)
        setShowShareMenu(true);
      }
    } catch (error) {
      console.error('Error sharing message:', error);
      // Always show custom share menu as fallback (which includes copy option)
      setShowShareMenu(true);
    }
  };

  // Copy to clipboard function - always available
  const copyShareMessage = async (referralUrl, referralCode) => {
    const shareMessage = `🎉 Join me on K9 Interiors! 
Use my referral code: ${referralCode}
Open this link and get exclusive rewards!
${referralUrl}
Happy shopping! 🛍️`;

    try {
      await navigator.clipboard.writeText(shareMessage);
      setUrlCopied(true);
      setShowShareMenu(false);
      setTimeout(() => setUrlCopied(false), 2000);
    } catch (error) {
      // Fallback for older browsers - always works
      const textArea = document.createElement('textarea');
      textArea.value = shareMessage;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setUrlCopied(true);
      setShowShareMenu(false);
      setTimeout(() => setUrlCopied(false), 2000);
    }
  };

  // Share to WhatsApp
  const shareToWhatsApp = (referralUrl, referralCode) => {
    const message = `🎉 Join me on K9 Interiors!\nUse my referral code: ${referralCode}\nOpen this link and get exclusive rewards!\n${referralUrl}\nHappy shopping! 🛍️`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank'); // opens in WhatsApp Web
    setShowShareMenu(false);
  };

  // Share to Gmail
  const shareToGmail = (referralUrl, referralCode) => {
    const subject = 'Join me on K9 Interiors!';
    const body = `🎉 Join me on K9 Interiors!

Use my referral code: ${referralCode}

Open this link and get exclusive rewards!
${referralUrl}

Happy shopping! 🛍️`;

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(gmailUrl, '_blank');
    setShowShareMenu(false);
  };
  const callCustomerDetails = async () => {
    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    let formData = new FormData();
    formData.append("customerId", userInfo?.id);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}customerdetailsbycustomerid?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          setUserInputData({
            name: data?.customerList?.[0]?.customerName,
            email: data?.customerList?.[0]?.customerEmail,
            mobileNo: data?.customerList?.[0]?.customerMobile
              ? data?.customerList?.[0]?.customerMobile?.substring(3)
              : "",
            alternativeMobileNo: data?.customerList?.[0]?.customerAlterMobile
              ? data?.customerList?.[0]?.customerAlterMobile?.substring(3)
              : "",
          });
          setUserDetails({
            customerName: data?.customerList?.[0]?.customerName,
            customerEmail: data?.customerList?.[0]?.customerEmail,
            customerMobile: data?.customerList?.[0]?.customerMobile,
            customerAlterMobile: data?.customerList?.[0]?.customerAlterMobile,
            customerWalletBalance: data?.customerList?.[0]?.walletBalance,
            customerReferralCode: data?.customerList?.[0]?.referralCode,
          });

          callAddressListApi();
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  const callAddressListApi = async () => {
    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    let formData = new FormData();
    formData.append("customerId", userInfo?.id);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}addressesbycustomer?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setAddressList(data?.addressList);
          callOrderListApi();
        } else if (data.message !== "Invalid token" || data.message === "Invalid Credentials.") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  const callOrderListApi = async () => {
    let formData = new FormData();
    formData.append("customerId", userInfo?.id);

    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}orderbycustomer?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          setOrderList(data?.customerOrderList);
          setOrderData(data?.customerOrderList);
          setloading(false);
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  const callRewardSettings = async () => {

    const requestOptions = {
      method: "GET",
    };
    fetch(
      `${process.env.REACT_APP_API_URL}rewardsettings`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token")
        ) {
          localStorage.clear();
          navigate("/logout");
        }
        if (data && data.status) {
          setRewardSettings(data?.rewardSettingList);

        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  useEffect(() => {
    callCustomerDetails();
    callRewardSettings();
  }, []);


  const getDynamicRedemptionConditions = () => {
    if (!rewardSettings) return [];

    // Create the redemption message based on redemptionBasedOn value
    let redemptionMessage = "";
    if (rewardSettings[0]?.redemptionBasedOn === "Value") {
      redemptionMessage = `You can use Maximum ${rewardSettings[0]?.maxRedemptionAmount} coins from the Total Wallet Balance`;
    } else if (rewardSettings[0]?.redemptionBasedOn === "Percentage") {
      redemptionMessage = `You can use Maximum ${rewardSettings[0]?.maxRedemptionAmount} Percent coins from the Total Wallet Balance`;
    } else {
      // Default message if value is neither "Value" nor "Percentage"
      redemptionMessage = `You can use Maximum ${rewardSettings[0]?.maxRedemptionAmount} ${rewardSettings[0]?.redemptionBasedOn || ""} from the Total Wallet Balance`;
    }

    return [
      `Maximum redemption coins is ${rewardSettings[0]?.maxRedemptionAmount}`,
      "Wallet balance can be used for any purchase on the platform",
      `Wallet credits expire after ${rewardSettings[0]?.points_expiry_days} months of inactivity`,
      "Wallet balance cannot be transferred to another account",
      "Redemption is not available for gift cards and subscription products",
      `Coins to Money Conversion Ratio: ${rewardSettings[0]?.points_to_currency_ratio} Coins = ₹1`,
      `Minimum Wallet Balance will be ${rewardSettings[0]?.min_points_to_redeem} Coins to Redeem Reward Coins`,
      `Minimum Order Amount will be ₹ ${rewardSettings[0]?.min_purchase_for_redemption} to Redeem Reward Coins`,
      redemptionMessage,
    ];
  };

  const handleSubmitAddAddress = async (e) => {
    e.preventDefault();

    if (!addressInputData?.address) {
      toast?.error("Please Enter a Address!", { toastId: "addressErr" });
      setAddressInputDataError({ ...addressInputDataError, address: true });
    } else if (addressInputData?.address?.length <= 2) {
      toast?.error("Please Enter a Proper Address!", {
        toastId: "addressErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, address: true });
    } else if (!addressInputData?.city) {
      toast?.error("Please Enter a City!", { toastId: "cityErr" });
      setAddressInputDataError({ ...addressInputDataError, city: true });
    } else if (addressInputData?.city?.length <= 2) {
      toast?.error("Please Enter a Proper City!", {
        toastId: "cityErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, city: true });
    } else if (!addressInputData?.state) {
      toast?.error("Please Enter a State!", { toastId: "stateErr" });
      setAddressInputDataError({ ...addressInputDataError, state: true });
    } else if (addressInputData?.state?.length <= 2) {
      toast?.error("Please Enter a Proper State!", {
        toastId: "stateErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, state: true });
    } else if (!addressInputData?.country) {
      toast?.error("Please Enter a Country!", { toastId: "countryErr" });
      setAddressInputDataError({ ...addressInputDataError, country: true });
    } else if (addressInputData?.country?.length <= 2) {
      toast?.error("Please Enter a Proper Country!", {
        toastId: "countryErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, country: true });
    } else if (!addressInputData?.pincode) {
      toast?.error("Please Enter a Pincode!", { toastId: "pincodeErr" });
      setAddressInputDataError({ ...addressInputDataError, pincode: true });
    } else if (addressInputData?.pincode?.length !== 6) {
      toast?.error("Please Enter a Proper Pincode!", {
        toastId: "pincodeErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, pincode: true });
    } else {
      setloading(true);
      let formData = new FormData();
      formData.append("customerId", userInfo?.id);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("customerAddress", addressInputData?.address);
      formData.append("customerCity", addressInputData?.city);
      formData.append("customerState", addressInputData?.state);
      formData.append("customerPincode", addressInputData?.pincode);
      formData.append("customerCountry", addressInputData?.country);
      formData.append("created_by", userInfo?.customerName);
      console.log("formData: ", formData);

      let token = localStorage.getItem("token");
      let ipAddress = localStorage.getItem("ipaddress");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}addcustomeraddress?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setOpenModal(false);
            setAddressInputData({
              address: "",
              city: "",
              state: "",
              pincode: "",
              country: "",
            });

            callAddressListApi();
          } else if (data.message !== "Invalid token") {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("AA2 There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  const handleEditAddressModal = (data) => {
    setEditAddressModal(true);
    setSelectedId(data?.id);
    setAddressInputData({
      ...addressInputData,
      address: data?.customerAddress,
      city: data?.customerCity,
      state: data?.customerState,
      country: data?.customerCountry,
      pincode: data?.customerPincode,
    });
  };

  const handleUpdateAddAddress = async (e) => {
    e.preventDefault();

    if (!addressInputData?.address) {
      toast?.error("Please Enter a Address!", { toastId: "addressErr" });
      setAddressInputDataError({ ...addressInputDataError, address: true });
    } else if (addressInputData?.address?.length <= 2) {
      toast?.error("Please Enter a Proper Address!", {
        toastId: "addressErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, address: true });
    } else if (!addressInputData?.city) {
      toast?.error("Please Enter a City!", { toastId: "cityErr" });
      setAddressInputDataError({ ...addressInputDataError, city: true });
    } else if (addressInputData?.city?.length <= 2) {
      toast?.error("Please Enter a Proper City!", {
        toastId: "cityErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, city: true });
    } else if (!addressInputData?.state) {
      toast?.error("Please Enter a State!", { toastId: "stateErr" });
      setAddressInputDataError({ ...addressInputDataError, state: true });
    } else if (addressInputData?.state?.length <= 2) {
      toast?.error("Please Enter a Proper State!", {
        toastId: "stateErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, state: true });
    } else if (!addressInputData?.country) {
      toast?.error("Please Enter a Country!", { toastId: "countryErr" });
      setAddressInputDataError({ ...addressInputDataError, country: true });
    } else if (addressInputData?.country?.length <= 2) {
      toast?.error("Please Enter a Proper Country!", {
        toastId: "countryErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, country: true });
    } else if (!addressInputData?.pincode) {
      toast?.error("Please Enter a Pincode!", { toastId: "pincodeErr" });
      setAddressInputDataError({ ...addressInputDataError, pincode: true });
    } else if (addressInputData?.pincode?.length !== 6) {
      toast?.error("Please Enter a Proper Pincode!", {
        toastId: "pincodeErr2",
      });
      setAddressInputDataError({ ...addressInputDataError, pincode: true });
    } else {
      setloading(true);
      let formData = new FormData();
      formData.append("customerId", userInfo?.id);
      formData.append("id", selectedId);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("customerAddress", addressInputData?.address);
      formData.append("customerCity", addressInputData?.city);
      formData.append("customerState", addressInputData?.state);
      formData.append("customerPincode", addressInputData?.pincode);
      formData.append("customerCountry", addressInputData?.country);
      formData.append("updated_by", userInfo?.customerName);
      console.log("formData: ", formData);

      let token = localStorage.getItem("token");
      let ipAddress = localStorage.getItem("ipaddress");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}editcustomeraddress?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setEditAddressModal(false);
            setSelectedId("");
            setAddressInputData({
              address: "",
              city: "",
              state: "",
              pincode: "",
              country: "",
            });

            callAddressListApi();
          } else if (data.message !== "Invalid token") {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("AA2 There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  const handleSubmitProfile = async (e) => {
    e.preventDefault();

    if (!userInputData?.name) {
      toast.error("Please Enter a Name!", { toastId: "nameErr" });
      setUserInputDataError({ ...userInputDataError, name: true });
    } else if (userInputData?.name?.length <= 2) {
      toast.error("Please Enter a Proper Full Name!", { toastId: "nameErr" });
      setUserInputDataError({ ...userInputDataError, name: true });
    } else if (!userInputData?.mobileNo) {
      toast.error("Please Enter a Mobile No!", { toastId: "mobileErr" });
      setUserInputDataError({ ...userInputDataError, mobileNo: true });
    } else if (userInputData?.mobileNo?.length !== 10) {
      toast.error("Please Enter a Proper Mobile No!", { toastId: "mobileErr" });
      setUserInputDataError({ ...userInputDataError, mobileNo: true });
    } else {
      setloading(true);
      let formData = new FormData();

      formData.append("id", userInfo?.id);
      formData.append("customerName", userInputData?.name);
      formData.append("customerMobile", `+91${userInputData?.mobileNo}`);
      formData.append("updated_by", userInfo?.customerName);
      if (userInputData?.alternativeMobileNo) {
        formData.append(
          "customerAlterMobile",
          `+91${userInputData?.alternativeMobileNo}`
        );
      }

      let token = localStorage.getItem("token");
      let ipAddress = localStorage.getItem("ipaddress");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}editcustomerprofile?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            toast.success("Record Updated Successfully!");
            callCustomerDetails();
          } else if (data.message !== "Invalid token") {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("AA2 There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (!changePasswordInputData?.oldPassword) {
      toast?.error("Please Enter a Old Password!", {
        toastId: "oldPasswordErr",
      });
      setChangePasswordInputDataError({
        ...changePasswordInputDataError,
        oldPassword: true,
      });
    } else if (!passwordRegex.test(changePasswordInputData?.oldPassword)) {
      toast?.error(
        "Please Enter a Old Password in Proper Format!, Password  contains at least one uppercase, one lowercase, one Sysmbol  and one number",
        { toastId: "oldPasswordErr2" }
      );
      setChangePasswordInputDataError({
        ...changePasswordInputDataError,
        oldPassword: true,
      });
    } else if (!changePasswordInputData?.newPassword) {
      toast?.error("Please Enter a New Password!", {
        toastId: "newPasswordErr",
      });
      setChangePasswordInputDataError({
        ...changePasswordInputDataError,
        newPassword: true,
      });
    } else if (!passwordRegex.test(changePasswordInputData?.newPassword)) {
      toast?.error(
        "Please Enter a New Password in Proper Format!, Password  contains at least one uppercase, one lowercase, one Sysmbol  and one number",
        { toastId: "newPasswordErr2" }
      );
      setChangePasswordInputDataError({
        ...changePasswordInputDataError,
        newPassword: true,
      });
    } else if (!changePasswordInputData?.confirmPassword) {
      toast?.error("Please Enter a Confirm Password!", {
        toastId: "ConfirmPasswordErr",
      });
      setChangePasswordInputDataError({
        ...changePasswordInputDataError,
        confirmPassword: true,
      });
    } else if (!passwordRegex.test(changePasswordInputData?.confirmPassword)) {
      toast?.error(
        "Please Enter a Confirm Password in Proper Format!, Password  contains at least one uppercase, one lowercase, one Sysmbol  and one number",
        { toastId: "ConfirmPasswordErr2" }
      );
      setChangePasswordInputDataError({
        ...changePasswordInputDataError,
        confirmPassword: true,
      });
    } else if (
      changePasswordInputData?.newPassword !==
      changePasswordInputData?.confirmPassword
    ) {
      toast.error("New Password and Confirm Password does not match");
    } else {
      setloading(true);

      let formData = new FormData();
      formData.append("username", userInfo?.customerEmail);
      formData.append("oldPassword", changePasswordInputData?.oldPassword);
      formData.append("newPassword", changePasswordInputData?.newPassword);
      formData.append("clientId", process.env.REACT_APP_Client_Id);

      let token = localStorage.getItem("token");
      let ipAddress = localStorage.getItem("ipaddress");

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}updatecustomerpassword?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" || data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            window.location.reload();
          }
          if (data && data.status) {
            setloading(false);

            setChangePasswordInputData({
              confirmPassword: "",
              newPassword: "",
              oldPassword: "",
            });
            toast.success("Password Updated Successfully");
          } else if (data.message !== "Invalid token") {
            setloading(false);
            toast.error(data?.message);
          }
        })
        .catch((error) => {
          setloading(false);
          setTimeout(() => {
            toast.error("AA2 There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  };

  const handleDeleteAddress = async (id) => {
    let token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    setloading(true);
    let formData = new FormData();
    formData.append("id", id);
    formData.append("clientId", process.env.REACT_APP_Client_Id);
    formData.append("isDelete", "YES");

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}deletecustomeraddress?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          callAddressListApi();
          setloading(false);
        } else if (data.message !== "Invalid token") {
          setloading(false);
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("AA2 There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };
  if (loading) return <Loader />;
  const redemptionConditions = getDynamicRedemptionConditions();
  return (
    <>
      <Breadcrumb
        mainTitle={`Hi ${userDetails?.customerName}`}
        title={"Profile"}
        subTitle={"Home"}
      />

      <section className="container ">
        <div className="row">
          <div
            data-aos="slide-right"
            data-aos-delay=""
            className="aos-init col-xl-3 col-lg-4"
          >
            <div
              style={{
                padding: 10,
                border: "1px solid #d9dbdd",
                borderRadius: 7,
                marginTop: 80,
                marginBottom: 80,
              }}
            >
              <ul style={{ padding: 15, listStyle: "none" }}>
                <li
                  style={{
                    padding: "7px 20px",
                    fontSize: 20,
                    fontWeight: step === "step1" && 800,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStep("step1");
                  }}
                >
                  Dashboard
                </li>
                <li
                  style={{
                    padding: "7px 20px",
                    fontSize: 20,
                    fontWeight: step === "step2" && 800,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStep("step2");
                  }}
                >
                  Orders
                </li>
                <li
                  style={{
                    padding: "7px 20px",
                    fontSize: 20,
                    fontWeight: step === "step3" && 800,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStep("step3");
                  }}
                >
                  Address
                </li>
                <li
                  style={{
                    padding: "7px 20px",
                    fontSize: 20,
                    fontWeight: step === "step4" && 800,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStep("step4");
                  }}
                >
                  Account Details
                </li>
                <li
                  style={{
                    padding: "7px 20px",
                    fontSize: 20,
                    fontWeight: step === "step7" && 800,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStep("step7");
                  }}
                >
                  My Wallet
                </li>
                <li
                  style={{
                    padding: "7px 20px",
                    fontSize: 20,
                    fontWeight: step === "step8" && 800,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStep("step8");
                  }}
                >
                  View My Referral Cycle
                </li>
                <li
                  style={{
                    padding: "7px 20px",
                    fontSize: 20,
                    fontWeight: step === "step5" && 800,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setStep("step5");
                  }}
                >
                  Change Password
                </li>
                <li
                  style={{
                    padding: "7px 20px",
                    fontSize: 20,
                    fontWeight: step === "step6" && 800,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    localStorage.clear();
                    navigate("/");
                    window.location.reload();
                    // setTimeout(() => {
                    //   router.reload();
                    // }, 200);
                  }}
                >
                  Sign Out
                </li>
              </ul>
            </div>
          </div>
          <div
            data-aos="slide-left"
            data-aos-delay=""
            style={{ marginTop: isMobile ? 0 : 80, marginBottom: 80 }}
            className="aos-init col-xl-9 col-lg-9"
          >
            {step === "step1" && (
              <div
                style={{
                  padding: 10,
                }}
              >
                <h3 className="unna-regular">Personal Information : </h3>
                <p>
                  These details are view-only. To make edits, please navigate to
                  the{" "}
                  <Link
                    onClick={() => {
                      setStep("step4");
                    }}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    {" "}
                    Account Details{" "}
                  </Link>{" "}
                  section.
                </p>
                <div>
                  <div>
                    <div className="row mt-40">
                      <div className="col-md-6 form-group">
                        <h6>Full Name : </h6>
                        <Input
                          style={{ cursor: "not-allowed", width: "80%" }}
                          className=" form-control mx-2 w-100 custom-profile-input"
                          type="text"
                          disabled
                          value={userDetails?.customerName}
                        />
                      </div>
                      <div className="col-md-6 form-group">
                        <h6>Email : </h6>
                        <Input
                          style={{ cursor: "not-allowed", width: "80%" }}
                          className="form-control mx-2 w-100 custom-profile-input"
                          type="text"
                          disabled
                          value={userDetails?.customerEmail}
                        />
                      </div>
                    </div>
                    <div className="row mt-20">
                      <div className="col-md-6 form-group">
                        <h6>Mobile : </h6>
                        <Input
                          style={{ cursor: "not-allowed", width: "80%" }}
                          className=" form-control mx-2 w-100 custom-profile-input"
                          type="text"
                          disabled
                          value={userDetails?.customerMobile}
                        />
                      </div>
                      <div className="col-md-6 form-group">
                        <h6>Alternative Mobile No : </h6>
                        <Input
                          style={{ cursor: "not-allowed", width: "80%" }}
                          className="form-control mx-2 w-100 custom-profile-input"
                          type="text"
                          disabled
                          value={userDetails?.customerAlterMobile}
                        />
                      </div>
                      {/* <div style={walletStyles.referralSection}>
                        <h2 style={walletStyles.walletTitle}>My Referral Code</h2>
                        <div style={walletStyles.copySection}>
                          <div style={walletStyles.pointLabel}>{userDetails?.customerReferralCode}</div>
                          <i
                            onClick={() => {
                              if (userDetails?.customerReferralCode) {
                                handleCopyReferralCode(userDetails.customerReferralCode);
                              }
                            }}
                            className={copied ? "fi fi-br-check" : "fi fi-br-copy"}
                            style={{
                              color: copied ? "#4CAF50" : "#32ba7c",
                              cursor: "pointer",
                              fontSize: "16px",
                              transition: "color 0.3s ease",
                              marginTop: '13px'
                            }}
                            title={copied ? "Copied!" : "Copy referral code"}
                          ></i>

                          <i
                            onClick={() => {
                              if (userDetails?.customerReferralCode) {
                                const referralUrl = `https://k9interior.com/${userDetails.customerReferralCode}`;
                                handleShareReferralUrl(referralUrl, userDetails?.customerReferralCode);
                              }
                            }}
                            className={urlCopied ? "fi fi-br-check" : "fi fi-br-share"}
                            style={{
                              color: urlCopied ? "#4CAF50" : "#32ba7c",
                              cursor: "pointer",
                              fontSize: "16px",
                              transition: "color 0.3s ease",
                              marginTop: '13px'
                            }}
                            title={urlCopied ? "URL Copied!" : "Share referral link"}
                          ></i>

                        </div>
                      </div> */}
                      <div style={walletStyles.referralSection}>
                        <h2 style={walletStyles.walletTitle}>My Referral Code</h2>
                        <div style={walletStyles.copySection}>
                          <div style={walletStyles.pointLabel}>{userDetails?.customerReferralCode}</div>
                          <i
                            onClick={() => {
                              if (userDetails?.customerReferralCode) {
                                handleCopyReferralCode(userDetails.customerReferralCode);
                              }
                            }}
                            className={copied ? "fi fi-br-check" : "fi fi-br-copy"}
                            style={{
                              color: copied ? "#4CAF50" : "#32ba7c",
                              cursor: "pointer",
                              fontSize: "16px",
                              transition: "color 0.3s ease",
                              marginTop: '13px',
                              marginRight: '10px'
                            }}
                            title={copied ? "Copied!" : "Copy referral code"}
                          ></i>
                          <i
                            onClick={() => {
                              if (userDetails?.customerReferralCode) {
                                const referralUrl = `https://k9interior.com/${userDetails.customerReferralCode}`;
                                handleShareReferralUrl(referralUrl, userDetails?.customerReferralCode);
                              }
                            }}
                            className={urlCopied ? "fi fi-br-check" : "fi fi-br-share"}
                            style={{
                              color: urlCopied ? "#4CAF50" : "#32ba7c",
                              cursor: "pointer",
                              fontSize: "16px",
                              transition: "color 0.3s ease",
                              marginTop: '13px'
                            }}
                            title={urlCopied ? "URL Copied!" : "Share referral link"}
                          ></i>
                        </div>

                        {/* Custom Share Menu */}
                        {showShareMenu && (
                          <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 1000,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}>
                            <div style={{
                              backgroundColor: 'white',
                              borderRadius: '12px',
                              padding: '20px',
                              minWidth: '280px',
                              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)'
                            }}>
                              <h3 style={{
                                margin: '0 0 15px 0',
                                textAlign: 'center',
                                color: '#333',
                                fontSize: '18px'
                              }}>Share Referral</h3>

                              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                <button
                                  onClick={() => {
                                    const referralUrl = `https://k9interior.com/${userDetails?.customerReferralCode}`;
                                    copyShareMessage(referralUrl, userDetails?.customerReferralCode);
                                  }}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '12px 16px',
                                    backgroundColor: '#f5f5f5',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    transition: 'background-color 0.2s'
                                  }}
                                  onMouseOver={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                                  onMouseOut={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                >
                                  <i className="fi fi-br-copy" style={{ color: '#32ba7c' }}></i>
                                  Copy to Clipboard
                                </button>

                                <button
                                  onClick={() => {
                                    const referralUrl = `https://k9interior.com/${userDetails?.customerReferralCode}`;
                                    shareToWhatsApp(referralUrl, userDetails?.customerReferralCode);
                                  }}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '12px 16px',
                                    backgroundColor: '#f5f5f5',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    transition: 'background-color 0.2s'
                                  }}
                                  onMouseOver={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                                  onMouseOut={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                >
                                  <i className="fi fi-brands-whatsapp" style={{ color: '#25D366' }}></i>
                                  Share on WhatsApp
                                </button>

                                <button
                                  onClick={() => {
                                    const referralUrl = `https://k9interior.com/${userDetails?.customerReferralCode}`;
                                    shareToGmail(referralUrl, userDetails?.customerReferralCode);
                                  }}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '12px 16px',
                                    backgroundColor: '#f5f5f5',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    transition: 'background-color 0.2s'
                                  }}
                                  onMouseOver={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                                  onMouseOut={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                >
                                  <i className="fi fi-brands-google" style={{ color: '#EA4335' }}></i>
                                  Share via Gmail
                                </button>
                              </div>

                              <button
                                onClick={() => setShowShareMenu(false)}
                                style={{
                                  width: '100%',
                                  marginTop: '15px',
                                  padding: '10px',
                                  backgroundColor: '#32ba7c',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  fontSize: '14px'
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {step === "step2" && (
              <div
                style={{
                  padding: 10,
                }}
              >
                <h3 className="unna-regular">Orders : </h3>
                <div className="table-responsive">
                  <table
                    className="custom-table-cart"
                    style={{
                      minWidth: 818,
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          width="50%"
                          style={{
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                            fontWeight: "normal",
                          }}
                        >
                          PRODUCT
                        </th>
                        <th
                          width="25%"
                          style={{
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                            fontWeight: "normal",
                          }}
                        >
                          PRICE
                        </th>
                        <th
                          width="25%"
                          style={{
                            textAlign: "left",
                            padding: "10px",
                            borderBottom: "1px solid #ddd",
                            fontWeight: "normal",
                          }}
                        >
                          ORDER DETAILS
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderList?.map((product, index) =>
                        product?.products?.map((item, i) => {
                          rowCount++;
                          // Calculate price with discount if applicable
                          let originalPrice = +parseFloat(item?.purchaseUnitPrice);
                          let finalPrice = originalPrice;
                          // if (item?.purchaseDiscountedPercentage !== null && item?.purchaseDiscountedPercentage !== "") {
                          //   const discountAmount = (originalPrice * parseInt(item?.productDetail?.discountedPercentage)) / 100;
                          //   console.log('discountAmount: ', discountAmount);
                          //   finalPrice = originalPrice - discountAmount;
                          // }
                          return (
                            <tr
                              data-aos="zoom-out-left"
                              className="aos-init"
                              key={i}
                              style={{
                                cursor: "pointer",
                                backgroundColor:
                                  rowCount % 2 === 0 ? "" : "#f5f0ee",
                              }}
                              onClick={() => handleRowClick(item?.id)}
                            >
                              <td
                                style={{
                                  padding: "20px 10px",
                                  borderBottom: "1px solid #ddd",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <button
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      padding: "5px",
                                      marginTop: 0,
                                      marginRight: "20px",
                                    }}
                                  >
                                    {/* {i + 1} */}
                                  </button>
                                  <img
                                    src={
                                      JSON.parse(
                                        item?.variantDetail?.variantImageGallery?.replace(
                                          /'/g,
                                          '"'
                                        )
                                      )[0]
                                    }
                                    alt="Ring"
                                    style={cartStyles.productImage}
                                  />
                                  <div
                                    style={{
                                      marginLeft: "20px",
                                    }}
                                  >
                                    <div
                                      className="unna-regular"
                                      style={{
                                        fontSize: 22,
                                        lineHeight: "26px",
                                      }}
                                    >
                                      {item?.productDetail?.productname}
                                    </div>
                                    <div className="jost-font mt-3">
                                      {
                                        item?.productDetail?.mainCategoryDetails
                                          ?.mainCategoryName
                                      }{" "}
                                      -{" "}
                                      {item?.productDetail?.categoryDetails
                                        ?.mainCategoryName &&
                                        `${item?.productDetail?.categoryDetails?.mainCategoryName}`}
                                    </div>
                                    <div className="jost-font">
                                      {item?.variantDetail?.id && (
                                        <>
                                          {
                                            item?.variantDetail?.variantkey?.split(
                                              "-"
                                            )[0]
                                          }{" "}
                                          {item?.variantDetail?.variantkey?.split(
                                            "-"
                                          )?.[1] &&
                                            `- ${item?.variantDetail?.variantkey?.split(
                                              "-"
                                            )?.[1]
                                            }`}
                                          {item?.variantDetail?.variantkey?.split(
                                            "-"
                                          )?.[2] &&
                                            `- ${item?.variantDetail?.variantkey?.split(
                                              "-"
                                            )?.[2]
                                            }`}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{
                                  padding: "20px 10px",
                                  borderBottom: "1px solid #ddd",
                                }}
                              >
                                <div style={cartStyles.productInfo}>
                                  <div className="jost-font">
                                    Price : Rs. {finalPrice.toFixed(2)}
                                  </div>
                                  <div className="jost-font ">
                                    Qty : {item?.qty}
                                  </div>
                                  <div className="jost-font">
                                    SubTotal : Rs.{" "}
                                    {parseFloat(
                                      +finalPrice.toFixed(2) * +item?.qty
                                    ).toFixed(2)}
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{
                                  padding: "20px 10px",
                                  borderBottom: "1px solid #ddd",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                  }}
                                >
                                  <div className="jost-font">
                                    Order Id : {item?.id}
                                  </div>
                                  <div className="jost-font ">
                                    Order Date :{" "}
                                    {product?.orderDate
                                      ? moment(
                                        product?.orderDate,
                                        "YYYY-MM-DD"
                                      ).format("DD  MMM   YY")
                                      : ""}
                                  </div>

                                  <div className="jost-font">
                                    Order Status : {product?.orderStatus}
                                  </div>


                                  {/* View Order Details{" "} */}
                                  {/* <SquareArrowOutUpRight
                                      size={18}
                                      className="px-2"
                                    /> */}
                                </div>
                              </td>
                            </tr>
                    );
                        })
                      )}
                  </tbody>
                </table>
              </div>
              </div>
            )}
          {step === "step3" && (
            <div
              style={{
                padding: 10,
              }}
            >
              <div className="accordion -simple row y-gap-20 js-accordion">
                <div className="col-12">
                  <div
                    className={`accordion__item px-20 py-15 border-1 rounded-12 
                       is-active
                    `}
                  >
                    <div
                      className="accordion__button d-flex items-center justify-between"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div className=" text-16 text-dark-1">
                        <p
                          style={{
                            fontSize: 18,
                            color: "black",
                            fontWeight: 600,
                          }}
                        >
                          Address
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          setOpenModal(true);
                        }}
                        className="accordion__icon size-30 flex-center bg-light-2 rounded-full"
                      >
                        <Plus size={16} color="black" />
                        <Plus size={16} color="black" />
                      </div>
                    </div>
                    <div
                      className="accordion__content"
                      style={{
                        maxHeight: 439,
                        overflow: "auto",
                        height: "100%",
                      }}
                    >
                      {addressList?.map((item, i) => (
                        <div
                          // onClick={(e) => {
                          //   setSelectedAddress(item?.id);
                          // }}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            padding: "15px 0",
                            borderBottom: "1px solid #e0e0e0",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <div>
                              {/* <input
                                  type="radio"
                                  name="contact"
                                  checked={selectedAddress === item?.id}
                                  style={styles.radio}
                                /> */}
                              <span
                                style={{
                                  fontWeight: "bold",
                                  marginRight: "10px",
                                }}
                              >
                                {item?.customerDetails?.customerName}
                              </span>
                              <span
                                style={{
                                  backgroundColor: "#e0e0e0",
                                  padding: "2px 6px",
                                  borderRadius: "4px",
                                  fontSize: "12px",
                                  marginRight: "10px",
                                }}
                              >
                                HOME
                              </span>
                              <span
                                style={{
                                  color: "#666",
                                  marginRight: "10px",
                                }}
                              >
                                {item?.customerDetails?.customerMobile}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <i
                                onClick={() => {
                                  handleEditAddressModal(item);
                                }}
                                class="fi fi-br-edit"
                                style={{
                                  color: "#32ba7c",
                                  cursor: "pointer",
                                }}
                              ></i>
                              <i
                                onClick={() => {
                                  handleDeleteAddress(item?.id);
                                }}
                                class="fa fa-trash mx-2"
                                style={{
                                  marginTop: -5,
                                  color: "#f06548",
                                  fontSize: 18,
                                  cursor: "pointer",
                                }}
                              ></i>
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#666",
                              fontSize: "14px",
                              flex: 1,
                              paddingLeft: 0,
                              width: "90%",
                            }}
                          >
                            {item?.customerAddress},{item?.customerCity},
                            {item?.customerState},{item?.customerPincode},
                            {item?.customerCountry}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {step === "step4" && (
            <div
              style={{
                padding: 10,
              }}
            >
              <h3 className="unna-regular">Account Details : </h3>

              <div>
                <div>
                  <div className="row mt-20">
                    <div className="col-md-6 form-group">
                      <h6>Full Name : </h6>
                      <Input
                        style={{
                          width: "80%",
                          padding: "10px",
                          marginBottom: "15px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          fontSize: "16px",
                        }}
                        className="custom-profile-input form-control w-100"
                        type="text"
                        value={userInputData?.name}
                        placeholder="Enter a Full Name"
                        onChange={(e) => {
                          const nonNumericRegex = /^[A-Za-z\s]+$/;
                          if (
                            nonNumericRegex.test(e.target.value) ||
                            e.target.value === ""
                          ) {
                            setUserInputData({
                              ...userInputData,
                              name: e.target.value,
                            });

                            if (e.target.value?.length >= 3) {
                              setUserInputDataError({
                                ...userInputDataError,
                                name: false,
                              });
                            } else {
                              setUserInputDataError({
                                ...userInputDataError,
                                name: true,
                              });
                            }
                          } else {
                            toast.error("Type Characters Only", {
                              toastId: "sysmbol",
                            });
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <h6>Email : </h6>
                      <Input
                        style={{
                          width: "80%",
                          padding: "10px",
                          marginBottom: "15px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          fontSize: "16px",
                        }}
                        className="form-control  w-100 custom-profile-input"
                        type="text"
                        disabled
                        value={userDetails?.customerEmail}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <h6>Mobile : </h6>
                      <Input
                        style={{
                          width: "80%",
                          padding: "10px",
                          marginBottom: "15px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          fontSize: "16px",
                        }}
                        className=" form-control custom-profile-input w-100"
                        type="number"
                        value={userInputData?.mobileNo}
                        placeholder="Enter a Mobile No"
                        onChange={(e) => {
                          if (e.target.value > 0 || e.target.value === "") {
                            setUserInputData({
                              ...userInputData,
                              mobileNo: e.target.value,
                            });

                            if (e.target.value?.length === 10) {
                              setUserInputDataError({
                                ...userInputDataError,
                                mobileNo: false,
                              });
                            } else {
                              setUserInputDataError({
                                ...userInputDataError,
                                mobileNo: true,
                              });
                            }
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <h6>Alternative Mobile No : </h6>
                      <Input
                        style={{
                          width: "80%",
                          padding: "10px",
                          marginBottom: "15px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          fontSize: "16px",
                        }}
                        className="form-control custom-profile-input w-100"
                        type="number"
                        value={userInputData?.alternativeMobileNo}
                        placeholder="Enter a Alternative Mobile No"
                        onChange={(e) => {
                          if (e.target.value > 0 || e.target.value === "") {
                            setUserInputData({
                              ...userInputData,
                              alternativeMobileNo: e.target.value,
                            });
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className=""
                    style={{
                      marginRight: 80,
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      type="button"
                      onClick={(e) => {
                        handleSubmitProfile(e);
                      }}
                      style={{
                        backgroundColor: "#00264d",
                        color: "white",
                        border: "none",
                        padding: "15px",
                        width: "100%",
                        fontSize: "16px",
                        fontWeight: "bold",
                        borderRadius: 8,
                        cursor: "pointer",
                        marginBottom: "10px",
                        marginTop: "10px",
                        maxWidth: 220,
                      }}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {step === "step5" && (
            <div
              style={{
                padding: 10,
              }}
            >
              <h3 className="unna-regular">Change Password : </h3>

              <div>
                <div>
                  <div className="row mt-20">
                    <div className="col-md-4 form-group">
                      <h6>Current Password : </h6>
                      <div style={{ position: "relative" }}>
                        <Input
                          style={{
                            width: "100%",
                            padding: "10px",
                            marginBottom: "15px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "16px",
                          }}
                          className="custom-profile-input form-control w-100"
                          type={oldShowPassword ? "text" : "password"}
                          placeholder="Enter a Old Password"
                          value={changePasswordInputData?.oldPassword}
                          onChange={(e) => {
                            const passwordRegex =
                              /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;

                            setChangePasswordInputData({
                              ...changePasswordInputData,
                              oldPassword: e.target.value.trim(),
                            });
                            if (
                              e.target.value.trim().length >= 3 &&
                              passwordRegex.test(e.target.value.trim())
                            ) {
                              setChangePasswordInputDataError({
                                ...changePasswordInputDataError,
                                oldPassword: false,
                              });
                            } else {
                              setChangePasswordInputDataError({
                                ...changePasswordInputDataError,
                                oldPassword: true,
                              });
                            }
                          }}
                        />

                        <span className="show-password-input-account">
                          {oldShowPassword ? (
                            <i
                              className="fa fa-eye"
                              onClick={() =>
                                setOldShowPassword(!oldShowPassword)
                              }
                              style={{ cursor: "pointer" }}
                            ></i>
                          ) : (
                            <i
                              className="fa fa-eye-slash"
                              onClick={() =>
                                setOldShowPassword(!oldShowPassword)
                              }
                              style={{ cursor: "pointer" }}
                            ></i>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4 form-group">
                      <h6>New Password: </h6>
                      <div style={{ position: "relative" }}>
                        <Input
                          style={{
                            width: "100%",
                            padding: "10px",
                            marginBottom: "15px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "16px",
                          }}
                          className="custom-profile-input form-control w-100"
                          type={newShowPassword ? "text" : "password"}
                          placeholder="Enter a New Password"
                          value={changePasswordInputData?.newPassword}
                          onChange={(e) => {
                            const passwordRegex =
                              /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;

                            setChangePasswordInputData({
                              ...changePasswordInputData,
                              newPassword: e.target.value.trim(),
                            });
                            if (
                              e.target.value.trim().length >= 3 &&
                              passwordRegex.test(e.target.value.trim())
                            ) {
                              setChangePasswordInputDataError({
                                ...changePasswordInputDataError,
                                newPassword: false,
                              });
                            } else {
                              setChangePasswordInputDataError({
                                ...changePasswordInputDataError,
                                newPassword: true,
                              });
                            }
                          }}
                        />

                        <span className="show-password-input-account">
                          {newShowPassword ? (
                            <i
                              className="fa fa-eye"
                              onClick={() =>
                                setNewShowPassword(!newShowPassword)
                              }
                              style={{ cursor: "pointer" }}
                            ></i>
                          ) : (
                            <i
                              className="fa fa-eye-slash"
                              onClick={() =>
                                setNewShowPassword(!newShowPassword)
                              }
                              style={{ cursor: "pointer" }}
                            ></i>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-4 form-group">
                      <h6>Confirm New Password : </h6>
                      <div style={{ position: "relative" }}>
                        <Input
                          style={{
                            width: "100%",
                            padding: "10px",
                            marginBottom: "15px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "16px",
                          }}
                          className="custom-profile-input form-control w-100"
                          type={confirmShowPassword ? "text" : "password"}
                          placeholder="Enter a Confirm Password"
                          value={changePasswordInputData?.confirmPassword}
                          onChange={(e) => {
                            const passwordRegex =
                              /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;

                            setChangePasswordInputData({
                              ...changePasswordInputData,
                              confirmPassword: e.target.value.trim(),
                            });
                            if (
                              e.target.value.trim().length >= 3 &&
                              passwordRegex.test(e.target.value.trim())
                            ) {
                              setChangePasswordInputDataError({
                                ...changePasswordInputDataError,
                                confirmPassword: false,
                              });
                            } else {
                              setChangePasswordInputDataError({
                                ...changePasswordInputDataError,
                                confirmPassword: true,
                              });
                            }
                          }}
                        />

                        <span className="show-password-input-account">
                          {confirmShowPassword ? (
                            <i
                              className="fa fa-eye"
                              onClick={() =>
                                setConfirmShowPassword(!confirmShowPassword)
                              }
                              style={{ cursor: "pointer" }}
                            ></i>
                          ) : (
                            <i
                              className="fa fa-eye-slash"
                              onClick={() =>
                                setConfirmShowPassword(!confirmShowPassword)
                              }
                              style={{ cursor: "pointer" }}
                            ></i>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="d-flex justify-content-end"
                    style={{ marginRight: 0 }}
                  >
                    <button
                      type="button"
                      onClick={(e) => {
                        handleUpdatePassword(e);
                      }}
                      style={{
                        backgroundColor: "#00264d",
                        color: "white",
                        border: "none",
                        padding: "15px",
                        width: "100%",
                        fontSize: "16px",
                        fontWeight: "bold",
                        borderRadius: 8,
                        cursor: "pointer",
                        marginBottom: "10px",
                        marginTop: "10px",
                        maxWidth: 220,
                      }}
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {step === "step7" && (
            <div style={walletStyles.container}>
              {/* Wallet Section */}
              <div style={walletStyles.walletSection}>
                <h2 style={walletStyles.walletTitle}>My Wallet</h2>
                <div>
                  <div style={walletStyles.balanceLabel}>Available Balance</div>
                  <div style={walletStyles.balanceWrapper}>
                    <div style={walletStyles.balanceAmount}>{userDetails?.customerWalletBalance} Coins</div>
                    <div>
                      <span style={walletStyles.coinIcon}></span>
                      <span style={walletStyles.coinIcon2}></span>
                      <span style={walletStyles.coinIcon}></span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Redemption Conditions */}
              <div style={walletStyles.redemptionSection}>
                <h3 style={walletStyles.redemptionTitle}>Redemption Conditions</h3>
                <ul style={walletStyles.conditionsList}>
                  {redemptionConditions.map((condition, index) => (
                    <li key={index} style={walletStyles.conditionItem}>
                      <span style={walletStyles.bulletPoint}>•</span>
                      <span>{condition}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

          )}
          {step === "step8" && (
            <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
              {/* Referral Tree Component */}
              <ReferralTreeComponent />
            </div>
          )}
        </div>
      </div>
    </section >

      { openModal && (
        <Modal
          open={openModal}
          onClose={() => {
            setOpenModal(false);
          }}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              position: "absolute",
              flexDirection: "column",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              maxWidth: 800,
              width: "100%",
              borderRadius: 2,
              border: "none",
              outline: "none",
              background: "white",
            }}
          >
            <div
              style={{
                textAlign: "left",
                backgroundColor: "rgb(0, 38, 77)",
                color: "white",
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                padding: "0px 20px",
              }}
              className="cust-modal-header"
            >
              <h3 className="jost-font p-2 text-white">Add New Address</h3>

              <IconButton
                aria-label="close"
                onClick={() => setOpenModal(false)}
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 15,
                }}
              >
                <i
                  className="fa fa-close "
                  style={{ fontSize: 25, color: "white" }}
                ></i>
              </IconButton>
            </div>

            <div style={{ width: "100%", padding: 33 }}>
              <form className="row" onSubmit={(e) => handleSubmitAddAddress(e)}>
                <div className="col-md-12 ">
                  {" "}
                  <input
                    type="text"
                    name="address"
                    placeholder="Address"
                    value={addressInputData?.address}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        address: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          address: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          address: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.address
                        ? "1px solid red"
                        : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6">
                  {" "}
                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={addressInputData?.city}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        city: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          city: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          city: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.city
                        ? "1px solid red"
                        : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6 pl-0 ">
                  {" "}
                  <input
                    type="text"
                    name="pinCode"
                    placeholder="State"
                    value={addressInputData?.state}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        state: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          state: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          state: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.state
                        ? "1px solid red"
                        : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6">
                  {" "}
                  <input
                    type="number"
                    name="pinCode"
                    placeholder="PIN code"
                    value={addressInputData?.pincode}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        pincode: e.target.value,
                      });

                      if (e.target.value.length === 6) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          pincode: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          pincode: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.pincode
                        ? "1px solid red"
                        : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                    }}
                  />
                </div>{" "}
                <div className="col-md-6 pl-0 ">
                  {" "}
                  <select
                    name="country"
                    disabled
                    value={addressInputData?.country}
                    onChange={(e) => {
                      setAddressInputData({
                        ...addressInputData,
                        country: e.target.value,
                      });

                      if (e.target.value.length >= 3) {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          country: false,
                        });
                      } else {
                        setAddressInputDataError({
                          ...addressInputDataError,
                          country: true,
                        });
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "10px",
                      marginBottom: "15px",
                      border: addressInputDataError?.country
                        ? "1px solid red"
                        : "1px solid #ccc",
                      borderRadius: "4px",
                      fontSize: "16px",
                      appearance: "none",
                      backgroundImage:
                        'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")',
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 10px top 50%",
                      backgroundSize: "12px auto",
                    }}
                  >
                    <option value="India">India</option>
                  </select>
                </div>{" "}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <button
                    type="submit"
                    style={{
                      backgroundColor: "#00264d",
                      color: "white",
                      border: "none",
                      padding: "15px",
                      width: "100%",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: 8,
                      cursor: "pointer",
                      marginBottom: "10px",
                      maxWidth: 220,
                    }}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </Box>
        </Modal>
      )
}
{
  editAddressModal && (
    <Modal
      open={editAddressModal}
      onClose={() => {
        setEditAddressModal(false);
      }}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          position: "absolute",
          flexDirection: "column",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: 800,
          width: "100%",
          borderRadius: 2,
          border: "none",
          outline: "none",
          background: "white",
        }}
      >
        <div
          style={{
            textAlign: "left",
            backgroundColor: "rgb(0, 38, 77)",
            color: "white",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 20px",
          }}
          className="cust-modal-header"
        >
          <h3 className="jost-font p-2 text-white">Update Address</h3>

          <IconButton
            aria-label="close"
            onClick={() => setEditAddressModal(false)}
            sx={{
              position: "absolute",
              top: 0,
              right: 15,
              background: "transparent",
            }}
          >
            <i
              className="fa fa-close "
              style={{ fontSize: 25, color: "white" }}
            ></i>
          </IconButton>
        </div>

        <div style={{ width: "100%", padding: 33 }}>
          <form className="row" onSubmit={(e) => handleUpdateAddAddress(e)}>
            <div className="col-md-12 ">
              {" "}
              <input
                type="text"
                name="address"
                placeholder="Address"
                value={addressInputData?.address}
                onChange={(e) => {
                  setAddressInputData({
                    ...addressInputData,
                    address: e.target.value,
                  });

                  if (e.target.value.length >= 3) {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      address: false,
                    });
                  } else {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      address: true,
                    });
                  }
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "15px",
                  border: addressInputDataError?.address
                    ? "1px solid red"
                    : "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "16px",
                }}
              />
            </div>{" "}
            <div className="col-md-6">
              {" "}
              <input
                type="text"
                name="city"
                placeholder="City"
                value={addressInputData?.city}
                onChange={(e) => {
                  setAddressInputData({
                    ...addressInputData,
                    city: e.target.value,
                  });

                  if (e.target.value.length >= 3) {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      city: false,
                    });
                  } else {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      city: true,
                    });
                  }
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "15px",
                  border: addressInputDataError?.city
                    ? "1px solid red"
                    : "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "16px",
                }}
              />
            </div>{" "}
            <div className="col-md-6 pl-0 ">
              {" "}
              <input
                type="text"
                name="pinCode"
                placeholder="State"
                value={addressInputData?.state}
                onChange={(e) => {
                  setAddressInputData({
                    ...addressInputData,
                    state: e.target.value,
                  });

                  if (e.target.value.length >= 3) {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      state: false,
                    });
                  } else {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      state: true,
                    });
                  }
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "15px",
                  border: addressInputDataError?.state
                    ? "1px solid red"
                    : "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "16px",
                }}
              />
            </div>{" "}
            <div className="col-md-6">
              {" "}
              <input
                type="number"
                name="pinCode"
                placeholder="PIN code"
                value={addressInputData?.pincode}
                onChange={(e) => {
                  setAddressInputData({
                    ...addressInputData,
                    pincode: e.target.value,
                  });

                  if (e.target.value.length === 6) {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      pincode: false,
                    });
                  } else {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      pincode: true,
                    });
                  }
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "15px",
                  border: addressInputDataError?.pincode
                    ? "1px solid red"
                    : "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "16px",
                }}
              />
            </div>{" "}
            <div className="col-md-6 pl-0 ">
              {" "}
              <select
                name="country"
                disabled
                value={addressInputData?.country}
                onChange={(e) => {
                  setAddressInputData({
                    ...addressInputData,
                    country: e.target.value,
                  });

                  if (e.target.value.length >= 3) {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      country: false,
                    });
                  } else {
                    setAddressInputDataError({
                      ...addressInputDataError,
                      country: true,
                    });
                  }
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "15px",
                  border: addressInputDataError?.country
                    ? "1px solid red"
                    : "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "16px",
                  appearance: "none",
                  backgroundImage:
                    'url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")',
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 10px top 50%",
                  backgroundSize: "12px auto",
                }}
              >
                <option value="India">India</option>
              </select>
            </div>{" "}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <button
                type="submit"
                style={{
                  backgroundColor: "#00264d",
                  color: "white",
                  border: "none",
                  padding: "15px",
                  width: "100%",
                  fontSize: "16px",
                  fontWeight: "bold",
                  borderRadius: 8,
                  cursor: "pointer",
                  marginBottom: "10px",
                  maxWidth: 220,
                }}
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </Box>
    </Modal>
  )
}
    </>
  );
};

export default Profile;
